import React, { useCallback } from 'react';
import { useDispatch } from "react-redux";
import { updateUserSetting } from "../../../../pages/LoginPage/reducer";
import { KEY_STORAGE, THEME_COLOR } from "../../../../util/varibles/constants";
import { PreferenceSetting } from "../../../../util/varibles/userSetting";
import { useTheme } from '../../../Theme/ThemeContext';
import styles from './style.module.scss';

const ThemeColor: React.FC = () => {

    const [theme, setTheme] = useTheme(state => state.theme);
    const dispatch = useDispatch();

    const changeColor = useCallback(() => {
        const value = theme === THEME_COLOR.LIGHT ? THEME_COLOR.DARK : THEME_COLOR.LIGHT;
        dispatch(updateUserSetting([
            { [PreferenceSetting.THEME_COLOR]: value }
        ]))
        localStorage.setItem(KEY_STORAGE.THEME, value);
        setTheme({ theme: value })
    }, [dispatch, setTheme, theme])

    return <div className={[styles.wrapper, 'change-theme'].join(' ')} onClick={changeColor}>
        <div />
    </div>;
};

export default React.memo(ThemeColor);
